import script from "./CWDFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CWDFilter.vue?vue&type=script&setup=true&lang=js"

import "./CWDFilter.vue?vue&type=style&index=0&id=13c1f4c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c1f4c8"]])

export default __exports__